import {
  Block,
  ButtonIcon,
  ButtonIconProps,
  ChevronRight,
  LabelSmall,
  Mats,
  mergeOverrides,
  SemanticTableProps,
} from "@mezo-org/mezo-clay"

import btcIcon from "#/assets/tokens/bitcoin-token-orange.svg"
import { getTokenIcon } from "#/shared/utils"

import Table from "../Governance/Table"
import { TokensIcons } from "../Token"

function PoolIcon() {
  return (
    <TokensIcons
      tokens={[
        { token: "chain", icon: getTokenIcon("MUSD") },
        { token: "BTC", icon: btcIcon },
      ]}
    />
  )
}
export function PoolNameCellContent({ name }: { name: string }) {
  return (
    <Block display="flex" alignItems="center">
      <PoolIcon />
      <LabelSmall marginLeft="scale500">{name}</LabelSmall>
    </Block>
  )
}

export function PoolTvlCellContent({ tvl }: { tvl: string }) {
  return <LabelSmall>{tvl}</LabelSmall>
}

export function PoolRewardsCellContent({ rewards }: { rewards: string }) {
  return (
    <Block display="flex" alignItems="center">
      <LabelSmall marginRight="scale300">{rewards}</LabelSmall>
      <Mats $size="1em" color="contentPrimary" />
    </Block>
  )
}

type PoolsProps = {
  columns?: React.ReactNode[]
  overrides?: SemanticTableProps["overrides"]
  onPoolClick?: ButtonIconProps["onClick"]
}

// "" - means column w/o a header to display an action button.
const defaultColumns = ["Pools", "TVL", "Total Rewards", ""]

const getPools = (onPoolClick: PoolsProps["onPoolClick"]) =>
  [
    { name: "CL1-MUSD/BTC", tvl: "$23,4M", rewards: "9,341" },
    { name: "CL10-MUSD/BTC", tvl: "$2,4M", rewards: "2,341" },
    { name: "CL100-MUSD/BTC", tvl: "$138,239", rewards: "29,341" },
  ].map((pool) => [
    <PoolNameCellContent name={pool.name} />,
    <PoolTvlCellContent tvl={pool.tvl} />,
    <PoolRewardsCellContent rewards={pool.rewards} />,
    <ButtonIcon
      size="small"
      shape="circle"
      colors={{ backgroundColor: "transparent", color: "inherit" }}
      overrides={{ BaseButton: { props: { "data-poolid": pool.name } } }}
      onClick={onPoolClick}
    >
      <ChevronRight size={20} />
    </ButtonIcon>,
  ])

const defaultOverrides: PoolsProps["overrides"] = {
  TableHeadCell: {
    style: {
      "th:nth-child(2)": { textAlign: "right" },
      "th:first-child": {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  TableBodyCell: {
    style: {
      width: 0,
      "td:nth-child(2)": { textAlign: "right" },
      "td:first-child": { width: "auto" },
    },
  },
}

export default function Pools({
  columns = defaultColumns,
  overrides,
  onPoolClick,
}: PoolsProps) {
  const mergedOverrides = mergeOverrides(defaultOverrides, overrides)

  return (
    <Table
      columns={columns}
      data={getPools(onPoolClick)}
      overrides={mergedOverrides}
    />
  )
}
